<template>
  <div>
    <CTabs variant="pills" class="mb-2" v-model="activeStatusTab" @update:activeTab="onTabChange">
      <CTab v-for="(tab, index) in statusTabs" :key="index" :title="tab"></CTab>
    </CTabs>
    <CRow v-if="orders.length">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CDataTable :striped="true" :items="orders" :fields="fields" :loading="isLoad">
              <template #type="{ item }">
                <td>
                  <CBadge shape="pill" class="p-2" color="secondary">{{ getOrderType(item.delivery_info) }}</CBadge>
                </td>
              </template>
              <template #sender_info="{ item }">
                <td>
                  <div>
                    <b>Name:</b> {{ item.sender_info.name }}
                  </div>
                  <div>
                    <b>Phone:</b> {{ item.sender_info.phone }}
                  </div>
                </td>
              </template>
              <template #recipient_info="{ item }">
                <td v-if="Object.keys(item.recipient_info).length > 0">
                  <div>
                    <b>Name:</b> {{ item.recipient_info.name }}
                  </div>
                  <div>
                    <b>Phone:</b> {{ item.recipient_info.phone }}
                  </div>
                </td>
                <td v-else>
                  <div>-</div>
                </td>
              </template>
              <template #delivery_info="{ item }">
                <td v-if="Object.keys(item.recipient_info).length > 0">
                  <div>
                    <b>Delivery Date:</b> {{ item.delivery_info.date }}
                  </div>
                  <div>
                    <b>Address:</b> {{ item.delivery_info.address }}
                  </div>
                  <div>
                    <b>Delivery Time:</b> {{ item.delivery_info.time ? item.delivery_info.time : '-' }}
                  </div>
                </td>
                <td v-else>
                  <div>
                    <b>Pickup Date:</b> {{ item.delivery_info.date }}
                  </div>
                  <div>
                    <b>Pickup Time:</b> {{ item.delivery_info.time ? item.delivery_info.time : '-' }}
                  </div>
                </td>
              </template>
              <template #created_at="{ item }">
                <td>
                  {{ dateFormatter(item.created_at) }}
                </td>
              </template>
              <template #status="{ item }">
                <td>
                  <CBadge shape="pill" class="p-2" :color="statusColors[item.status]">{{ item.status }}</CBadge>
                </td>
              </template>
              <template #action="{ item }">
                <td class="d-flex flex-column">
                  <CButton class="mb-2" size="sm" color="secondary" @click="viewItem(item)">
                    View
                  </CButton>
                  <template v-for="btn in statusChangers">
                    <CButton v-if="item.status === btn.fromStatus" :color="btn.color" style="text-wrap: nowrap;" 
                      size="sm" @click="changeOrderStatus(item.id, btn.label, btn.toStatus)">
                      {{ btn.label }}
                    </CButton>
                  </template>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <!-- Modal -->
    <CModal title="Modal title" :closeOnBackdrop="false" :centered="true" :show.sync="modalVisible.view">
      <CRow>
        <CCol :sm="6" v-for="(product, index) in selectedOrder.products" :key="index">
          <CCard color="light">
            <CCardBody>
              <h5 class="mb-3">{{ product.name }}</h5>
              <CCardSubtitle>
                <div v-if="product.selectedSize" class="mb-3">
                  <div>Size: {{ product.selectedSize.size }}</div>
                </div>
                <div class="mb-3">{{ getProductPrice(product) }}</div>
                <div v-if="product.message.message !== ''">
                  <div>Message: {{ product.message.message }}</div>
                  <div>From: {{ product.message.from }}</div>
                  <div>To: {{ product.message.to }}</div>
                </div>
              </CCardSubtitle>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="d-flex justify-content-between">
          <p>Sub Total:</p> 
          <p>{{ moneyFormatter(countSubTotal(selectedOrder.products)) }}</p>
        </CCol>
        <CCol sm="12" class="d-flex justify-content-between">
          <p>Delivery Cost:</p> 
          <p>{{ moneyFormatter(selectedOrder.delivery_cost) || 'FREE' }}</p>
        </CCol>
        <CCol sm="12" class="d-flex justify-content-between">
          <p style="font-weight: bold;">Total Cost:</p>
          <p style="font-weight: bold;">{{ moneyFormatter(countSubTotal(selectedOrder.products) + selectedOrder.delivery_cost) }}</p>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Order Purchase</h5>
        <CButtonClose @click="dismissModal" />
      </template>
      <template #footer>
        <CButton v-if="selectedOrder.status === 'PENDING'" color="danger" style="text-wrap: nowrap;" 
          @click="changeOrderStatus(selectedOrder.id, 'Cancel', 'CANCELLED')">
          Cancel Order
        </CButton>
        <div v-else></div>
      </template>
    </CModal>
    <CModal title="Modal title" color="danger" :closeOnBackdrop="false" :centered="true"
      :show.sync="modalVisible.changeStatus">
      Are you sure you want to {{changeStatus.label.toLowerCase()}} this order ?
      <template #header>
        <h5 class="modal-title">{{changeStatus.label}} Order</h5>
        <CButtonClose @click="dismissModal" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="updateOrderStatus(changeStatus.id, changeStatus.toStatus)" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <!-- Pagination -->
    <CPagination v-if="orders.length" :activePage.sync="page" :double-arrows="false" :pages="getPage"
      @update:activePage="changePage" />
  </div>
</template>

<script>
import {
  ORDER_UPDATE,
  ORDER_GET,
} from '../../../constants/api'
import dateFormatter from '../../../utils/dateFormatter'
import moneyFormatter from '../../../utils/moneyFormatter'

import axios from 'axios'

export default {
  data() {
    return {
      dateFormatter,
      moneyFormatter,
      orders: [],
      selectedOrder: {},
      fields: [
        'id', 'type', 'sender_info', 'recipient_info', 'delivery_info', 'note', 'created_at', 'status', 'action'
      ],
      modalVisible: {
        view: false,
        changeStatus: false,
      },
      page: 1,
      limit: 10,
      totalPage: 1,
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
      activeStatusTab: 0,
      statusTabs: [
        'All',
        'Pending',
        'Confirmed',
        'Completed',
        'Cancelled'
      ],
      statusColors: {
        'PENDING': 'warning',
        'CANCELLED': 'danger',
        'CONFIRMED': 'info',
        'COMPLETED': 'success'
      },
      statusChangers: [
        {
          label: 'Confirm',
          color: 'primary',
          fromStatus: 'PENDING',
          toStatus: 'CONFIRMED'
        },
        {
          label: 'Complete',
          color: 'success',
          fromStatus: 'CONFIRMED',
          toStatus: 'COMPLETED'
        },
      ],
      changeStatus: {
        id: '',
        toStatus: '',
        label: ''
      }
    }
  },

  beforeMount() {
    const payload = {
      start: 0,
    }
    this.fetchOrders(payload)
  },

  computed: {
    getPage() {
      return Math.ceil(this.totalPage / this.limit)
    },
  },

  methods: {
    fetchOrders(payload) {
      this.isLoad = true

      axios.get(ORDER_GET, {
        headers: {
          'x-access-token': this.accessToken
        },
        params: payload
      })
        .then(res => {
          this.orders = res.data.data
          this.limit = res.data.limitNum
          this.totalPage = res.data.totalCount
          this.isLoad = false
          this.dismissModal()
        })
    },

    onTabChange(e) {
      this.page = 1
      this.fetchOrders({start: 0, status: this.statusTabs[e]})
    },

    changePage(pageNumber) {
      const payload = {
        start: (pageNumber - 1) * this.limit
      }
      this.fetchOrders(payload)
    },

    viewItem(order) {
      this.selectedOrder = order
      this.modalVisible.view = true
    },

    countSubTotal(products) {
      if (!products) return 0
      return products.reduce((prev, current) => {
        return parseInt(prev) + parseInt(current.selectedSize?.price || current.price)
      }, 0)
    },

    changeOrderStatus(itemId, label, toStatus) {
      this.modalVisible.changeStatus = true
      this.changeStatus.id = itemId
      this.changeStatus.label = label
      this.changeStatus.toStatus = toStatus
    },
    updateOrderStatus(itemId, newStatus) {
      const payload = {
        status: newStatus
      }
      axios.put(`${ORDER_UPDATE}${itemId}`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.fetchOrders())
    },

    dismissModal() {
      this.changeStatus = {
        id: '',
        toStatus: '',
        label: ''
      }
      this.selectedOrder = {}
      this.modalVisible.view = false
      this.modalVisible.changeStatus = false
    },

    getProductPrice(product) {
      if (product.selectedSize) {
        return moneyFormatter(product.selectedSize.price)
      } else {
        return moneyFormatter(product.price)
      }
    },

    getOrderType(deliveryInfo) {
      if (!deliveryInfo) return null
      return deliveryInfo.address ? 'DELIVERY' : 'PICKUP'
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 1167px) {
  .fix-margin {
    margin-left: 0 !important;
  }
}
</style>